import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedModule } from '../../../../shared/shared.module';
import { IKkm, RegStatus } from '../../../../core/modules/retail-places/retail-paces.types';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { ModalService } from '../../../../core/modal/modal.service';
import { CancelDisconnectionOfdModalComponent } from '../../cancel-disconnection-ofd-modal/cancel-disconnection-ofd-modal.component';
import { ChangeOfdModalComponent } from '../../change-ofd-modal/change-ofd-modal.component';
import { IsnaEnabledService } from '../../shared/services/isna-enabled.service';
import { Pages } from '../../../pages';

@UntilDestroy()
@Component({
  selector: 'tax-kkm-reg-status-block',
  templateUrl: './kkm-reg-status-block.component.html',
  styleUrls: ['./kkm-reg-status-block.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    SharedModule,
  ],
})

export class KkmRegStatusBlockComponent {
  @Input() kkm?: IKkm & KkmAvailableOperations;
  readonly regStatus: typeof RegStatus = RegStatus;

  constructor(
    private modalService: ModalService,
    private isnaEnabledService: IsnaEnabledService,
    private router: Router,
  ) {}

  goToRegisterPage(kkmId: number, fnsKkmId?: string): void {
    const url = `${Pages.Kkms}/register-kkm/${kkmId}`;
    if (fnsKkmId) {
      this.isnaEnabledService.checkIsnaEnabled().pipe(untilDestroyed(this))
        .subscribe({
          next: () => this.router.navigateByUrl(`${url}?isChangingOfd=true`),
        });
    } else this.router.navigateByUrl(url);
  }

  openChangeOfdModal(kkmId: number): void {
    this.isnaEnabledService.checkIsnaEnabled().pipe(untilDestroyed(this))
      .subscribe({
        next: () => this.modalService.openOld(ChangeOfdModalComponent, {
          kkmId,
        }),
      });
  }

  openCancelDisconnectionOfdModal(kkmId: number): void {
    this.isnaEnabledService.checkIsnaEnabled().pipe(untilDestroyed(this))
      .subscribe({
        next: () => this.modalService.openOld(CancelDisconnectionOfdModalComponent, {
          kkmId,
        }),
      });
  }
}
